<template>
  <svg :width="size" :height="size" :viewBox="viewBox">
      <g>
        <path d="M 32.921875 24.496094 C 34.828125 22.371094 36 19.574219 36 16.5 C 36 9.882812 30.617188 4.5 24 4.5 C 17.382812 4.5 12 9.882812 12 16.5 C 12 23.117188 17.382812 28.5 24 28.5 C 26.332031 28.5 28.503906 27.820312 30.347656 26.664062 C 36.875 29.121094 41.367188 35.09375 41.9375 42 L 6.0625 42 C 6.453125 37.351562 8.632812 33.015625 12.179688 29.921875 C 12.804688 29.378906 12.871094 28.433594 12.324219 27.808594 C 11.78125 27.183594 10.835938 27.117188 10.210938 27.660156 C 5.625 31.65625 3 37.425781 3 43.5 C 3 44.328125 3.671875 45 4.5 45 L 43.5 45 C 44.328125 45 45 44.328125 45 43.5 C 45 35.269531 40.230469 27.921875 32.921875 24.496094 Z M 15 16.5 C 15 11.535156 19.035156 7.5 24 7.5 C 28.964844 7.5 33 11.535156 33 16.5 C 33 21.464844 28.964844 25.5 24 25.5 C 19.035156 25.5 15 21.464844 15 16.5 Z M 15 16.5 "/>
      </g>
    </svg>

</template>

<script>
export default {
  props: {
    size: {
      type: [Number, String],
      default: 48
    },
    box: {
      type: [Number, String],
      default: 48
    }
  },
  computed: {
    viewBox() {
      return `0 0 ${this.box} ${this.box}`
    }
  }
}

</script>

<style scoped>
svg {
  align-items: center;
  /*display: inline-block;*/
  /*vertical-align: baseline;*/
  /*margin-bottom: -2px; !* yes, I'm that particular about formatting *!*/
}
</style>